import { render, staticRenderFns } from "./ReceiverCreditListPage.vue?vue&type=template&id=096601a6&"
import script from "./ReceiverCreditListPage.vue?vue&type=script&lang=js&"
export * from "./ReceiverCreditListPage.vue?vue&type=script&lang=js&"
import style0 from "./ReceiverCreditListPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports